<template>
  <div class="signature-pad">
    <VueSignaturePad
      :customStyle="signaturePadStyle"
      :options="signaturePadOptions"
      width="600px"
      height="200px"
      ref="signaturePad"
    />
    <canvas class="capture" ref="capture" />
    <div>
      <button @click="save">Save</button>
      <button @click="undo">Undo</button>
    </div>
  </div>
</template>

<style lang="scss">
canvas.capture {
  background-color: red;
}
</style>

<script>
import Vue from "vue";
import VueSignaturePad from "vue-signature-pad";
Vue.use(VueSignaturePad);

export default {
  name: "MySignaturePad",
  data() {
    return {
      signaturePadOptions: {
        penColor: "red",
      },
      signaturePadStyle: {
        border: "3px solid black",
        "background-color": "gray",
      },
      capturedSignature: "",
    };
  },
  methods: {
    undo() {
      this.$refs.signaturePad.undoSignature();
    },
    save() {
      const { isEmpty, data } = this.$refs.signaturePad.saveSignature();
      console.log(isEmpty);
      console.log(data);
      const canvas = this.$refs.signaturePad.$el.getElementsByTagName(
        "canvas"
      )[0];
      const ctx = canvas.getContext("2d");
      const w = parseInt(canvas.width);
      const h = parseInt(canvas.height);
      const imageData = ctx.getImageData(0, 0, w, h).data;
      let minX = w,
        minY = h,
        maxX = 0,
        maxY = 0;
      for (let i = 0; i < imageData.length; i += 4) {
        const idx = Math.floor(i / 4);
        const x = Math.floor(idx % w);
        const y = Math.floor(idx / w);
        const inXrange = x < minX || x > maxX;
        const inYrange = y < minY || y > maxY;
        if (inXrange || inYrange) {
          const isColored = imageData[i + 3] > 0; // Gibts es Alpha, ist dort ein Pixel
          /*
        console.log(
          `rect: [${x},${y}]: [${imageData[i]}, ${imageData[i + 1]}, ${
            imageData[i + 2]
          }, ${imageData[i + 3]}]`
        );
        */
          if (isColored && inXrange) {
            minX = Math.min(minX, x);
            maxX = Math.max(maxX, x);
          }
          if (isColored && inYrange) {
            minY = Math.min(minY, y);
            maxY = Math.max(maxY, y);
          }
        }
      }

      if (minX < maxX) {
        // Unterschrift erkannt
        // ctx.strokeRect(minX, minY, maxX - minX + 1, maxY - minY + 1);

        const exWidth = maxX - minX + 1;
        const exHeight = maxY - minY + 1;
        console.log(`rect: [${minX},${minY}]+[${exWidth},${exHeight}]`);

        const croppedImageData = ctx.getImageData(
          minX,
          minY,
          exWidth,
          exHeight
        );
        const temp = document.createElement("canvas");
        temp.width = exWidth;
        temp.height = exHeight;
        const tempDraw = temp.getContext("2d");
        tempDraw.putImageData(croppedImageData, 0, 0);

        const pngData = temp.toDataURL("image/png");
        this.$znaApi.updateSignature(pngData).subscribe(retval => {
          window.alert('Unterschrift gespeichert');
        }, err => {
          window.alert('Unterschrift nicht gespeichert :(');
        });
        const img = new Image();
        img.src = pngData;
        ctx.strokeRect(
          minX,
          minY,
          exWidth,
          exHeight
        );
        this.$refs.signaturePad.$el.parentElement.parentElement.appendChild(
          img
        );
        img.onload = () => {
          // img.style.display = 'none';
          console.log(`Image dimensions: ${img.width}x${img.height}`);
        };
      } else {
        // Keine Unterschrift erkannt
      }
    },
  },
  mounted() {
    this.$refs.capture.width = this.$refs.signaturePad.width;
    this.$refs.capture.height = this.$refs.signaturePad.height;
  },
};
</script>
